import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { projectDetailPagesEnabled } from '../data/featuredProjects'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/projects/:slug',
    name: 'Project',
    component: () =>
      import(/* webpackChunkName: "project" */ '../views/ProjectDetail.vue'),
    beforeEnter (to, from, next) {
      if (!projectDetailPagesEnabled) {
        next({ name: 'Home' })
        return
      }
      next()
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

export default router
